/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { createObservableDataAction, IAction, IActionInput } from '@msdyn365-commerce/core';
import { GenericInput, getGenericAction } from '@msdyn365-commerce-modules/retail-actions';

export interface IRatingsReviewsState {
    filterKey: string;
}

export function createRatingsReviewsStateInput(result: IRatingsReviewsState): GenericInput<IRatingsReviewsState> {
    return new GenericInput<IRatingsReviewsState>('ratingsReviewsState', result, 'ratingsReviewsStateInput');
}

const createInternalRatingsReviewsStateInput = (): IActionInput => {
    return createRatingsReviewsStateInput({ filterKey: '1;2;3;4;5' });
};

export const getGenericActionDataAction = createObservableDataAction({
    action: <IAction<IRatingsReviewsState>>getGenericAction,
    input: createInternalRatingsReviewsStateInput
});

export default getGenericActionDataAction;
